<script>
</script>

<div class="container py-5">
  <div class="row">
    <div class="col-lg-8 mx-auto">
      <h1 class="mb-4">Penghapusan Data Pengguna</h1>
      <h2 class="h4 mb-3">Data Deletion Instructions</h2>
      
      <p class="lead">
        Penghapusan data tersedia untuk <strong>semua pengguna Kalender Bali, di negara mana pun</strong>,
        terlepas dari cara Anda mendaftar (email, Google, atau Facebook). Tersedia dua cara di bawah ini.
        <br>
        Data deletion is available to <strong>all Kalender Bali users, in every country</strong>,
        regardless of how you signed up (email, Google, or Facebook). Two methods are available below.
      </p>

      <h2 class="h4 mt-5 mb-3">Cara 1 — Melalui Aplikasi / Method 1 — In the App</h2>

      <div class="card mb-4">
        <div class="card-body">
          <h3 class="h5 card-title">Cara Menghapus Data Anda dari Kalender Bali</h3>
          <p class="card-text">
            Jika Anda masih dapat masuk ke akun Anda, silakan ikuti langkah-langkah berikut:
          </p>

          <ol class="mb-0">
            <li class="mb-2">
              Buka aplikasi <strong>Kalender Bali</strong> di perangkat iOS atau Android Anda
            </li>
            <li class="mb-2">
              Masuk ke <strong>Settings</strong>
            </li>
            <li class="mb-2">
              Lakukan <strong>Login</strong> terlebih dahulu jika belum login
            </li>
            <li class="mb-2">
              Setelah login, masuk kembali ke <strong>Settings</strong> → <strong>Account</strong>
            </li>
            <li class="mb-2">
              Klik tombol <strong>Delete Account</strong> untuk menghapus akun dan semua data yang terkait
            </li>
          </ol>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-body">
          <h3 class="h5 card-title">How to Delete Your Data from Kalender Bali</h3>
          <p class="card-text">
            If you can still sign in to your account, please follow these steps:
          </p>

          <ol class="mb-0">
            <li class="mb-2">
              Open the <strong>Kalender Bali</strong> app on your iOS or Android device
            </li>
            <li class="mb-2">
              Go to <strong>Settings</strong>
            </li>
            <li class="mb-2">
              <strong>Login</strong> to your account if you haven't already
            </li>
            <li class="mb-2">
              After logging in, go back to <strong>Settings</strong> → <strong>Account</strong>
            </li>
            <li class="mb-2">
              Click the <strong>Delete Account</strong> button to permanently delete your account and all associated data
            </li>
          </ol>
        </div>
      </div>

      <h2 class="h4 mt-5 mb-3">Cara 2 — Permintaan via Email / Method 2 — Request by Email</h2>

      <div class="card mb-4">
        <div class="card-body">
          <h3 class="h5 card-title">Jika Anda Tidak Dapat Masuk ke Aplikasi</h3>
          <p class="card-text">
            Anda tetap dapat menghapus data Anda tanpa menggunakan aplikasi. Cara ini berlaku jika Anda:
          </p>
          <ul>
            <li class="mb-1">sudah menghapus (uninstall) aplikasi Kalender Bali;</li>
            <li class="mb-1">telah mencabut izin Kalender Bali dari akun Facebook Anda, atau menghapus akun Facebook Anda;</li>
            <li class="mb-1">kehilangan akses ke email, kata sandi, atau metode login Anda;</li>
            <li class="mb-1">tidak lagi memiliki perangkat iOS atau Android.</li>
          </ul>
          <p class="card-text">
            Kirim email ke
            <a href="mailto:info@kalender-bali.id?subject=Data%20Deletion%20Request"><strong>info@kalender-bali.id</strong></a>
            dengan subjek <strong>“Data Deletion Request”</strong>, dan sertakan:
          </p>
          <ol>
            <li class="mb-1">alamat email atau nama akun yang Anda gunakan di Kalender Bali;</li>
            <li class="mb-1">metode login yang Anda pakai (email, Google, atau Facebook).</li>
          </ol>
          <p class="card-text mb-0">
            Kami akan memverifikasi identitas Anda, lalu menghapus akun beserta seluruh data terkait
            dari server kami dalam waktu <strong>maksimal 30 hari</strong>, dan mengirimkan konfirmasi
            melalui email setelah penghapusan selesai. Layanan ini gratis.
          </p>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-body">
          <h3 class="h5 card-title">If You Cannot Sign In to the App</h3>
          <p class="card-text">
            You can still have your data deleted without using the app. Use this method if you:
          </p>
          <ul>
            <li class="mb-1">have uninstalled the Kalender Bali app;</li>
            <li class="mb-1">have removed Kalender Bali's permissions from your Facebook account, or deleted your Facebook account;</li>
            <li class="mb-1">have lost access to your email, password, or login method;</li>
            <li class="mb-1">no longer have an iOS or Android device.</li>
          </ul>
          <p class="card-text">
            Send an email to
            <a href="mailto:info@kalender-bali.id?subject=Data%20Deletion%20Request"><strong>info@kalender-bali.id</strong></a>
            with the subject <strong>“Data Deletion Request”</strong>, and include:
          </p>
          <ol>
            <li class="mb-1">the email address or account name you used with Kalender Bali;</li>
            <li class="mb-1">the login method you used (email, Google, or Facebook).</li>
          </ol>
          <p class="card-text mb-0">
            We will verify your identity, then delete your account and all associated data from our
            servers within <strong>30 days at the latest</strong>, and send you an email confirmation
            once the deletion is complete. This service is free of charge.
          </p>
        </div>
      </div>

      <div class="alert alert-info">
        <h4 class="alert-heading">Data yang Dihapus / Data to be Deleted</h4>
        <p class="mb-0">
          Dengan cara mana pun di atas, semua data pribadi Anda
          (termasuk event, informasi login, dan data pengguna lainnya)
          akan dihapus secara permanen dari server kami dan tidak dapat dikembalikan.
          Kami tidak menyimpan salinan cadangan data Anda setelah masa penghapusan selesai,
          kecuali jika penyimpanan tersebut diwajibkan oleh hukum yang berlaku.
          <br><br>
          With either method above, all your personal data
          (including events, login information, and other user data)
          will be permanently deleted from our servers and cannot be recovered.
          We do not retain backup copies of your data after the deletion period,
          except where retention is required by applicable law.
        </p>
      </div>

      <div class="mt-4">
        <p>
          <strong>Pertanyaan? / Questions?</strong><br>
          Jika Anda memiliki pertanyaan tentang penghapusan data, silakan hubungi kami di
          <a href="mailto:info@kalender-bali.id">info@kalender-bali.id</a>.
          <br>
          If you have any questions about data deletion, please contact us at
          <a href="mailto:info@kalender-bali.id">info@kalender-bali.id</a>.
        </p>
      </div>
    </div>
  </div>
</div>

<style>
  .card {
    border: 1px solid rgba(0,0,0,.125);
  }
  
  .alert-info {
    background-color: #d1ecf1;
    border-color: #bee5eb;
    color: #0c5460;
  }
  
  ol li {
    line-height: 1.6;
  }
</style>
